import type { ReactNode } from "react"
import { cn } from "@/ui/lib/utils"

type Props = {
  /** The filter controls, laid out left to right */
  readonly children: ReactNode
  /**
   * Controls that narrow nothing — sort order, for instance — set apart at
   * the far end so they don't read as one more filter
   */
  readonly trailing?: ReactNode
  readonly className?: string
}

/**
 * The control row above a table.
 *
 * The fields carry no visible labels: each names itself through its
 * placeholder, which keeps the bar to a single tidy line. `Field` is
 * `w-full` by default, so every control would otherwise claim a row of
 * its own — each one therefore passes its own width through `className`.
 * Sizing stays with the caller because the sensible width differs per
 * filter: a status has a handful of short options, a workspace picker
 * holds arbitrary names.
 */
export default function FilterBar({ children, trailing, className }: Props) {
  return (
    <div className={cn("flex flex-wrap items-center gap-3", className)}>
      {children}
      {!!trailing && (
        <div className="flex items-center gap-3 sm:ml-auto">{trailing}</div>
      )}
    </div>
  )
}
